import axios from 'axios'
import { BUSCAR_USUARIOS_EMPRESA_AGENCIA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarUsuariosEmpresaAgencia (idEmpresa, idUsuarioEmpresa) {

  const url = `${URL}/usuarios-empresa-agencia/usuario-empresa/${idUsuarioEmpresa}/empresa/${idEmpresa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_USUARIOS_EMPRESA_AGENCIA,
        payload: response

      })
  );
}
